import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube, Twitter, MapPin, Phone, Mail } from 'lucide-react';
import { company } from '../../mock';

const social = [
  { Ic: Facebook, href: 'https://www.facebook.com/ewenrealtors/' },
  { Ic: Instagram, href: 'https://www.instagram.com/ewenrealtors/' },
  { Ic: Linkedin, href: 'https://www.linkedin.com/company/ewenrealtors' },
  { Ic: Twitter, href: 'https://twitter.com/EwenRealtors' },
  { Ic: Youtube, href: 'https://www.youtube.com/channel/UCEHZDj1RG_PA1wUqlE4l4kQ' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0f1a14] text-white/80 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 grid gap-12 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="h-10 w-10 rounded-full bg-[#ffff] grid place-items-center text-[#0f1a14] font-serif text-lg font-bold">
            <img src="/logo.svg" alt="" />
            </div>
            <div>
              <div className="font-serif text-white text-lg">Ewen Realtors</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#c9a56a]">Defining Dreams</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-white/60">
            Uttarakhand&apos;s most trusted real&#8209;estate company. Building homes, stories and legacies since 2013.
          </p>
          <div className="flex gap-3 mt-6">
            {social.map(({ Ic, href }, i) => (
              <a key={i} href={href} target="_blank" rel="noreferrer" className="h-9 w-9 grid place-items-center border border-white/15 hover:border-[#c9a56a] hover:text-[#c9a56a] transition-colors">
                <Ic className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-serif text-white mb-5 text-lg">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {[['/', 'Home'], ['/about', 'About Us'], ['/services', 'Services'], ['/blog', 'Blog'], ['/media', 'Gallery']].map(([to, l]) => (
              <li key={to}><Link to={to} className="hover:text-[#c9a56a] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-white mb-5 text-lg">Company</h4>
          <ul className="space-y-3 text-sm">
            {[['/investors', 'Investors'], ['/careers', 'Careers'], ['/faqs', 'FAQs'], ['/contact', 'Contact Us']].map(([to, l]) => (
              <li key={to}><Link to={to} className="hover:text-[#c9a56a] transition-colors">{l}</Link></li>
            ))}
          </ul>
          <h4 className="font-serif text-white mb-5 text-lg mt-8">Policies</h4>
          <ul className="space-y-3 text-sm">
            {[['/disclaimer', 'Disclaimer'], ['/privacy-policy', 'Privacy Policy'], ['/terms-and-conditions', 'Terms & Conditions'], ['/refund-policy', 'Refund Policy']].map(([to, l]) => (
              <li key={to}><Link to={to} className="hover:text-[#c9a56a] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-white mb-5 text-lg">Reach Us</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><MapPin className="h-4 w-4 text-[#c9a56a] shrink-0 mt-1" /><span className="text-white/60">{company.address}</span></li>
            <li className="flex gap-3"><Phone className="h-4 w-4 text-[#c9a56a] shrink-0 mt-1" /><a href={`tel:${company.phone}`} className="hover:text-[#c9a56a]">{company.phone}</a></li>
            <li className="flex gap-3"><Mail className="h-4 w-4 text-[#c9a56a] shrink-0 mt-1" /><a href={`mailto:${company.email}`} className="hover:text-[#c9a56a]">{company.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>&copy; {new Date().getFullYear()} Ewen Realtors. All rights reserved.</div>
          <div>RERA No. {company.rera}</div>
        </div>
      </div>
    </footer>
  );
}
